module.exports = __webpack_public_path__ + "static/media/horsham.f70bbd47.svg";